import config from 'configs';
import { LOADING, LOADED } from 'constants/data';
import { gameFilters } from 'constants/games';
import { getDbetData, getGamesData } from 'store/selectors';

import {
  FETCH_GAMES,
  SET_ACTIVE_FILTER,
  SET_SELECTED_GAME,
  SET_FAVORITE_GAMES,
  SET_SELECTED_GAME_ID,
  SET_GAMES_RTP_WITH_ID,
  FETCH_GAMES_CATEGORIES,
  SET_CATEGORIES_LOADING_STATUS,
  SET_CASINO_GAMES_LOADING_STATUS,
} from './actionTypes';

const { dbetApiUrl } = config;

const skinId = process.env.REACT_APP_PARTNER_ID;

const { ALL_GAMES, FAVORITES } = gameFilters;

export const setSelectedGame = payload => ({
  type: SET_SELECTED_GAME,
  payload,
});

export const fetchGameCategories = () => async dispatch => {
  dispatch({
    type: SET_CATEGORIES_LOADING_STATUS,
    payload: LOADING,
  });

  try {
    const res = await fetch(`${dbetApiUrl}/config/categories?partnerId=${skinId}`);

    const { categories, totalGameCount } = await res.json();

    var sortOrders = {
      otherGames: 10,
    };

    categories.sort(
      (a, b) =>
        (sortOrders[a.name] ? sortOrders[a.name] : 1) -
        (sortOrders[b.name] ? sortOrders[b.name] : 1),
    );

    dispatch({
      type: FETCH_GAMES_CATEGORIES,
      payload: [
        { categoryId: ALL_GAMES, name: ALL_GAMES, gameCount: totalGameCount },
        { categoryId: FAVORITES, name: FAVORITES },
        ...categories,
      ],
    });
  } catch (err) {
    console.error(err);
  } finally {
    dispatch({
      type: SET_CATEGORIES_LOADING_STATUS,
      payload: LOADED,
    });
  }
};

export const fetchGames = (category, offset, limit) => async dispatch => {
  dispatch({
    type: SET_CASINO_GAMES_LOADING_STATUS,
    payload: {
      category,
      status: LOADING,
    },
  });

  try {
    const res = await fetch(
      `${dbetApiUrl}/config/games?partnerId=${skinId}&lang=eng&offset=${offset}&limit=${limit}${
        category === ALL_GAMES ? '' : `&categoryId=${category}`
      }`,
    );
    const { games = [] } = (await res.json()) || {};

    dispatch({
      type: FETCH_GAMES,
      payload: {
        ...games,
        category,
        games: games,
      },
    });
  } catch (err) {
    console.error(err);
  } finally {
    dispatch({
      type: SET_CASINO_GAMES_LOADING_STATUS,
      payload: {
        category,
        status: LOADED,
      },
    });
  }
};

export const setFavoriteGame = payload => ({
  type: SET_FAVORITE_GAMES,
  payload,
});

export const filterIsActive = payload => ({
  type: SET_ACTIVE_FILTER,
  payload,
});

export const setSelectedGameId = payload => ({
  type: SET_SELECTED_GAME_ID,
  payload,
});

export const getGamesRTP = payload => async (dispatch, getStore) => {
  const store = getStore();
  const dbet = getDbetData(store);
  const games = getGamesData(store, payload);
  const gamesIDs = games.map(({ externalGameId }) => externalGameId);

  const gamesRTPWithID = await dbet.gamesRTP(gamesIDs);

  dispatch({
    type: SET_GAMES_RTP_WITH_ID,
    payload: gamesRTPWithID,
  });
};
